import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';
import { GetUserAccess } from '../store/insight-configuration.action';
import { ConfigurationState } from '../store/insight-configuration.state';

/* istanbul ignore */
@Injectable({
  providedIn: 'root'
})
export class RoleAccessService  {

  constructor(private store: Store, private router: Router) {}

  public resolve() {
    const hasAccess = this.store.selectSnapshot(ConfigurationState.userHasAccess);
    if(hasAccess === null) {
      return this.store.dispatch(new GetUserAccess())
      .pipe(
        map(() => this.store.selectSnapshot(ConfigurationState))
      )
    }
    return hasAccess;
  }


}
